module.exports = __webpack_public_path__ + "static/media/contact.e44d23ae.png";